import '../Components/notFound.css'

function NotFound() {
    return(
        <div className="notFound">
            <img 
            src={"/CookieMissingTexture.png"}
            alt='Cookie with a missing textures and a question mark'
            width={200}
            />
            <h1>Error: 404</h1>
            <h2>Page not Found</h2>
            <p>It seems like you're a little lost...</p>
            <small>or Brian has made a mistake...</small>
            <p><a href="/">Go Back to Home Page</a></p>
        </div>
    );
}

export default NotFound;